import { render, staticRenderFns } from "./approvalConfiguration.vue?vue&type=template&id=0b2b4bc2&scoped=true"
import script from "./approvalConfiguration.vue?vue&type=script&lang=js"
export * from "./approvalConfiguration.vue?vue&type=script&lang=js"
import style0 from "./approvalConfiguration.vue?vue&type=style&index=0&id=0b2b4bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2b4bc2",
  null
  
)

export default component.exports